import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const remindPassBtn = this.element.querySelector('.remind-password');
        const gotToLoginBtn = this.element.querySelector('.return-to-login');

        remindPassBtn.addEventListener('click', (e) => {
            e.preventDefault();

            this.element.querySelector('.right .login-tab').classList.add('hidden');
            this.element.querySelector('.right .remind-password-tab').classList.remove('hidden');
        });

        gotToLoginBtn.addEventListener('click', (e) => {
            e.preventDefault();

            this.element.querySelector('.right .login-tab').classList.remove('hidden');
            this.element.querySelector('.right .remind-password-tab').classList.add('hidden');
        })
    }
}
